import { useState, useCallback, useMemo } from 'react';
import TranscriptSidebarAsync from 'call-timeline-event/components/TranscriptSidebarAsync';
import { OPEN_TRANSCRIPT_SIDEBAR } from 'crm-events-data';
import CommunicatorLogger from 'customer-data-tracking/loggers/CommunicatorLogger';
import { useHistory } from 'react-router-dom';
import { addQueryParams, removeQueryParamsWithoutReload } from './navigationUtils';
import { useUpgradeEventListener } from 'ui-addon-upgrades/ums/useUpgradeEventListener';
import { jsx as _jsx } from "react/jsx-runtime";
const TRANSCRIPT_QUERY_PARAM = 'callSidebarOpen';
export const useTranscriptSidebarActionHandler = ({
  query
}) => {
  useUpgradeEventListener(); // Hook for TranscriptSidebar(Iframe) PQL
  const history = useHistory();
  const queryEngagementId = useMemo(() => {
    const rawQueryEngagementId = query[TRANSCRIPT_QUERY_PARAM];
    return rawQueryEngagementId ? +rawQueryEngagementId : null;
  }, [query]);
  const [transcriptEngagementId, setTranscriptEngagementId] = useState(queryEngagementId);
  const handleTranscriptSidebarAction = useCallback((actionType, data) => {
    if (actionType === OPEN_TRANSCRIPT_SIDEBAR) {
      const {
        engagementId,
        hasVoicemail
      } = data;
      setTranscriptEngagementId(engagementId);
      addQueryParams(history, {
        [TRANSCRIPT_QUERY_PARAM]: engagementId
      }, false);
      CommunicatorLogger.log('communicator_timelineInteraction', {
        action: 'View call transcript',
        activity: 'call',
        channel: 'outbound call',
        hasVoicemail: `${Boolean(hasVoicemail)}`
      });
      return;
    }
    return;
  }, [setTranscriptEngagementId, history]);
  const handleCloseTranscriptSidebar = useCallback(() => {
    setTranscriptEngagementId(null);
    removeQueryParamsWithoutReload(history, [TRANSCRIPT_QUERY_PARAM]);
  }, [setTranscriptEngagementId, history]);
  const transcriptSidebar = useMemo(() => {
    if (!transcriptEngagementId) {
      return null;
    }
    return /*#__PURE__*/_jsx(TranscriptSidebarAsync, {
      "data-unit-test": "transcript-sidebar",
      onCloseSidebar: handleCloseTranscriptSidebar,
      engagementId: transcriptEngagementId
    });
  }, [handleCloseTranscriptSidebar, transcriptEngagementId]);
  return {
    handleTranscriptSidebarAction,
    transcriptSidebar
  };
};